import { FETCH_PHARMACYORDERS_REQUEST,FETCH_PHARMACYORDERS_SUCCESS,FETCH_PHARMACYORDERS_FAILURE,FETCH_LABORDERS_REQUEST,FETCH_LABORDERS_SUCCESS,FETCH_LABORDERS_FAILURE } from "../actions/orderActions";

const initialState = {
    pharmacyOrders: [],
    labOrders:[],
    isLoading: false,
    error: null
};

export const ordersReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PHARMACYORDERS_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_PHARMACYORDERS_SUCCESS:
            return { ...state, pharmacyOrders: action.payload, isLoading: false };

        case FETCH_PHARMACYORDERS_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_LABORDERS_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_LABORDERS_SUCCESS:
            return { ...state, labOrders: action.payload, isLoading: false };

        case FETCH_LABORDERS_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        default:
            return state;
    }
};